// ゆるい擬似アイデンティティ＆訪問履歴（localStorage）
// cookie_id / my_participants は、この端末での「自分の回答行」を特定するために使う（マイ予定の横断表示）。

const COOKIE_KEY = 'entangle_cookie_id'
const VISITED_KEY = 'entangle_visited'
const MINE_KEY = 'entangle_my_participants'

export function getCookieId(): string {
  let id = localStorage.getItem(COOKIE_KEY)
  if (!id) {
    id = crypto.randomUUID()
    localStorage.setItem(COOKIE_KEY, id)
  }
  return id
}

export interface VisitedEvent {
  id: string
  title: string
  at: number
}

export function getVisited(): VisitedEvent[] {
  try {
    return JSON.parse(localStorage.getItem(VISITED_KEY) ?? '[]') as VisitedEvent[]
  } catch {
    return []
  }
}

export function addVisited(id: string, title: string): void {
  const list = getVisited().filter((v) => v.id !== id)
  list.unshift({ id, title, at: Date.now() })
  localStorage.setItem(VISITED_KEY, JSON.stringify(list.slice(0, 30)))
}

export function removeVisited(id: string): void {
  localStorage.setItem(VISITED_KEY, JSON.stringify(getVisited().filter((v) => v.id !== id)))
}

// このブラウザで「自分が作った回答行」を覚えておく（cookie_id をサーバーから出さずに本人特定するため）
export function getMyParticipants(): Record<string, string> {
  try {
    return JSON.parse(localStorage.getItem(MINE_KEY) ?? '{}') as Record<string, string>
  } catch {
    return {}
  }
}

export function setMyParticipant(eventId: string, participantId: string): void {
  const map = getMyParticipants()
  map[eventId] = participantId
  localStorage.setItem(MINE_KEY, JSON.stringify(map))
}

export function removeMyParticipant(eventId: string): void {
  const map = getMyParticipants()
  delete map[eventId]
  localStorage.setItem(MINE_KEY, JSON.stringify(map))
}
